import Button from '__core/modules/atoms/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export default function EditorialAccessErrorScreen({ onRetry }) {
  const { t } = useTranslation(['digitalPrograms', 'users', 'actions']);
  const history = useHistory();
  const errorRef = React.useRef(null);

  // El árbol anterior se desmonta, así que el foco caería en <body> y el aviso no se anunciaría.
  React.useEffect(() => {
    errorRef.current?.focus();
  }, []);

  return (
    <main className="error-boundary-page">
      <div>
        <div role="alert">
          <h1 className="text-title-strong" ref={errorRef} tabIndex={-1}>
            {t('digitalPrograms:access_unavailable')}
          </h1>
        </div>

        {/* Esta pantalla sustituye al árbol entero: sin una salida, quien llega aquí se queda sin
            menú ni forma de cambiar de cuenta, y solo sale escribiendo /logout a mano. */}
        <Button onClick={onRetry} text={t('users:editorial_access_retry')} variant="inline" />
        <Button color="transparent" onClick={() => history.push('/logout')} text={t('actions:logout')} variant="inline" />
      </div>
    </main>
  );
}

EditorialAccessErrorScreen.propTypes = { onRetry: PropTypes.func.isRequired };
